
export const _hop = (o: any, p: PropertyKey): boolean => Object.prototype.hasOwnProperty.call(o, p);


export function splitWords(value: string) {
	const regEx = /([A-Za-z]?)([a-z]+)/g;

	const output: string[] = [];
	let match = regEx.exec(value);
	while (match) {
		output.push([match[1].toUpperCase(), match[2]].join(''));
		match = regEx.exec(value);
	}

	return output.join(' ');

}


export function groupBy<T, TKey, TGroup>(items: T[], getKey: ((i: T) => TKey), getValue: ((i: T) => TGroup)) {
	const grouping = {} as any;
	for (let i = 0; i < items.length; i++) {
		const item = items[i];
		const key = getKey(item);
		if (!grouping[key]) {
			grouping[key] = [];
		}
		grouping[key].push(getValue ? getValue(item) : item);
	}
	return grouping;
}

export const flatMap = <T, TT>(arr: T[], select: ((v: T) => TT[])) => arr.reduce((acc, val) => acc.concat(select(val)), [] as TT[]);

export 	function sortByVariation(data) {
	return data.sort((v1, v2) => {
		if (v1.variation === '' && v2.variation !== '') {
			return -1;
		}
		if (v1.variation !== '' && v2.variation === '') {
			return 1;
		}
		return v1.variation.localeCompare(v2.variation);
	});
}
export function sortByVariationNameOrTag(data) {
	return data.sort((v1, v2) => {
		if (v1.NameOrTag === 'var1' && v2.NameOrTag !== 'var1') {
			return -1;
		}
		if (v1.NameOrTag !== 'var1' && v2.NameOrTag === 'var1') {
			return 1;
		}
		return v1.NameOrTag.localeCompare(v2.NameOrTag);
	});
}

// eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
export function sortByVariationId(data) {
	return data.sort((v1, v2) => {
		const [var1, num1] = v1.groupName.split(' ');
		const [var2, num2] = v2.groupName.split(' ');

		if (var1 === 'Baseline') {
			return -1;
		}
		if (var2 === 'Baseline') {
			return 1;
		}

		if (var1 === 'var1' && var2 !== 'var1') {
			return -1;
		}
		if (var1 !== 'var1' && var2 === 'var1') {
			return 1;
		}

		if (num1 < num2) {
			return -1;
		}
		if (num1 > num2) {
			return 1;
		}

		return 0;
	});
}